import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-person.tsx
/**
* icon.24.person
*
* Person, user, individual
*
* Keywords: user, profile, account, avatar, identity, circle, head, silhouette
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTUgOWEzIDMgMCAxIDEtNiAwIDMgMyAwIDAgMSA2IDBtMSAwYTQgNCAwIDEgMS04IDAgNCA0IDAgMCAxIDggMG0tOS43NSA4LjAwNmEuNDguNDggMCAwIDAgLjA1NC42MTJjLjIzMy4yMzUuNjE5LjE2Ny44MTEtLjEwM0E1Ljk5IDUuOTkgMCAwIDEgMTIgMTVjMi4wMTQgMCAzLjc5Ny45OTIgNC44ODUgMi41MTUuMTkyLjI3LjU3OC4zMzguODEuMTAyYS40OC40OCAwIDAgMCAuMDU0LS42MTFBNi45OSA2Ljk5IDAgMCAwIDEyIDE0YTYuOTkgNi45OSAwIDAgMC01Ljc1IDMuMDA2IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-9599
*/
const Icon24Person = memo(function Icon24Person(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M15 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0m1 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-9.75 8.006a.48.48 0 0 0 .054.612c.233.235.619.167.811-.103A5.99 5.99 0 0 1 12 15c2.014 0 3.797.992 4.885 2.515.192.27.578.338.81.102a.48.48 0 0 0 .054-.611A6.99 6.99 0 0 0 12 14a6.99 6.99 0 0 0-5.75 3.006",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon24Person };

//# sourceMappingURL=icon-24-person.js.map